var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.item.CtaUrl != "" ? "a" : "div",
    {
      tag: "component",
      staticClass: "card-outer col-md col-md-4",
      class: _vm.item.CtaUrl == "" ? "no-link" : "",
      attrs: {
        href: _vm.item.CtaUrl != "" ? _vm.item.CtaUrl : null,
        target:
          _vm.item.CtaUrl != ""
            ? _vm.item.CtaUrl.indexOf("/") == 0
              ? "_self"
              : "_blank"
            : null
      }
    },
    [
      _c("div", { staticClass: "card card-callout" }, [
        _vm.item.Image
          ? _c(
              "div",
              {
                staticClass: "card-img",
                attrs: { "aria-label": _vm.item.Title }
              },
              [
                _c("img", {
                  attrs: { src: _vm.item.Image, alt: _vm.item.AltText }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("span", { staticClass: "icon icon-arrow-right" }),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.item.Title))]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.item.CalloutCardDescription))]),
          _vm._v(" "),
          _c("div", { staticClass: "cta-link" }, [_vm._v(_vm._s(_vm.item.Cta))])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }